import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectors, sliceKeys } from '../../model';
import { useDeskNamesQuery } from '../../api/desk';

const selectCompanyId = selectors[sliceKeys.companies].selectCurrentId;

export const useDeskNamesQueryParams = () => {
  const storeCompanyId = useSelector(selectCompanyId);
  const location = useLocation();

  const serviceCompanyId = storeCompanyId || location.state?.from?.companyId;

  return useMemo(() => ({ serviceCompanyId }), [serviceCompanyId]);
};

export const useDeskNamesData = ({ options } = {}) => {
  const params = useDeskNamesQueryParams();

  return useDeskNamesQuery({ params, options });
};
